import {useDebugValue} from 'react';

import {undef} from '../../../utils/undef';

import {useTranslations} from './useTranslations';

const defaultDetailsModalTranslations = {
    titleMessage: 'Search',
    closeButtonLabel: 'Close',
    secondaryActionLabel: undef
};

function useDetailsModalTranslations(props) {
    const {
        detailsModalTranslations: propsDetailsModalTranslations
    } = props;

    const {
        translations: detailsModalTranslations
    } = useTranslations(defaultDetailsModalTranslations, propsDetailsModalTranslations);

    const result = {
        detailsModalTranslations
    };

    useDebugValue(result);

    return result;
}

export {useDetailsModalTranslations};
